import { render, staticRenderFns } from "./NormalType.vue?vue&type=template&id=4c56c610"
import script from "./NormalType.vue?vue&type=script&lang=js"
export * from "./NormalType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports